<template>
	<button
			class="text-button secondary button p-0"
			:class="'size-'+size"
			:disabled="disabled"
			@click.prevent.stop="onClick"
	>
			<slot name="icon"></slot>
			{{ label }}
	</button>
</template>
<script>
	export default{
		name: 'SimplementsLinkSecondaryButton',
		props: {
			label: {
				type: String
			},
			disabled: {
				type: Boolean
			},
			size: {
				type: String,
				default: 'lg'
			},
			width: {
				type: String,
				default: 'full'
			}
		},
		methods: {
			onClick(event){
				this.$emit('click', event)
			}
		}
	}
</script>
<style scoped>
	@import url(./assets/basic.css);
	.button.text-button.secondary{
		color: var(--neutral50, #8D8D8D) !important;
	}

	.button.text-button:hover{
		color: var(--neutral10, #333) !important;
	}
	.button.text-button:disabled{
		color: var(--neutral50, #8D8D8D) !important;
	}
</style>